// extracted by mini-css-extract-plugin
export default {"slideImg":"ProductDetailSlideImg_slideImg__iuYc3","slideImgWrapper":"ProductDetailSlideImg_slideImgWrapper__9xD1M"};